import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";
const error = ref(null)


export const getAllServicesList= async (token, client_id="", options = {})=>{
    log("welcome in  getAllServicesList from web")
    if(!token || token==""){
        alert("No token in getAllServicesList")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getAllServicesListApi'
        log("url="+url)
        const params = {
            client_id: client_id
        };

        // Add optional parameters for client filtering
        if (options.subclient_id) {
            params.subclient_id = options.subclient_id
        }
        if (options.include_subclients !== undefined) {
            params.include_subclients = options.include_subclients
        }

        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getAllServicesList")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getAllServicesList")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getAllServicesList",servicesList:{}}
    }
}
export const getPrepaidCardsServicesList= async (token, client_id="")=>{
    log("welcome in  getPrepaidCardsServicesList from web")
    if(!token || token==""){
        alert("No token in getPrepaidCardsServicesList")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/get_available_imsi_services_list_api'
        log("url="+url)
        const params = {
            client_id: client_id
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getPrepaidCardsServicesList")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getPrepaidCardsServicesList")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getPrepaidCardsServicesList",servicesList:{}}
    }
}
export const getImsiServiceDetailsApi= async (token, client_id="", service_id=null)=>{
    log("welcome in  getImsiServiceDetailsApi from web")
    if(!token || token==""){
        alert("No token in getImsiServiceDetailsApi")
    }
    else if(!service_id || service_id==""){
        alert("No service_id in getImsiServiceDetailsApi")
    }
    else{
        try{
            const headers= {
                "Authorization":`Bearer ${token}`,
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
            log(headers)
            log("g1")
            log("BASE_URL="+BASE_URL)
            let url=BASE_URL+'/home/get_imsi_service_details_api'
            log("url="+url)
            const params = {
                client_id: client_id,
                service_id: service_id
            };
            const result= await axios.get(url,  {headers: headers, params})
            log("g2")
            log("result.data din axios getImsiServiceDetailsApi")
            log(result.data)
            log("g3 returnam service_details")
            return result.data
        }catch(err){
            alert("alerta de eroare get getImsiServiceDetailsApi")
            log(err.value)
            // error.value = err.message
            return {error:true, message:"eroare la getImsiServiceDetailsApi",service_details:{}}
        }
    }
}

export const terminateService = async (token, serviceId, terminateExistingCs = false) => {
    log("welcome in terminateService from web")
    if (!token || token === "") {
        alert("No token in terminateService")
        return { error: true, message: "No token provided" }
    }
    if (!serviceId) {
        alert("No serviceId in terminateService")
        return { error: true, message: "No serviceId provided" }
    }
    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        let url = BASE_URL + '/home/terminate_service_api'
        log("url=" + url)
        const data = {
            service_id: serviceId,
            terminate_existing_cs: terminateExistingCs
        }
        const result = await axios.post(url, data, { headers: headers })
        log("result.data din axios terminateService")
        log(result.data)
        return result.data
    } catch (err) {
        log("Error in terminateService")
        log(err)
        return { error: true, message: "Error terminating service: " + err.message }
    }
}

export const getAvailableServicesList= async (token, client_id="")=>{
    log("welcome in  getAvailableServicesList from web")
    if(!token || token==""){
        alert("No token in getAvailableServicesList")
    }
    if(!client_id || client_id==""){
        alert("No client_id in getAvailableServicesList")
    }
    try{
        const headers= {
            "Authorization":`Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }
        log(headers)
        log("g1")
        log("BASE_URL="+BASE_URL)
        let url=BASE_URL+'/home/getAvailableServicesListApi'
        log("url="+url)
        const params = {
            client_id: client_id
        };
        const result= await axios.get(url,  {headers: headers, params})
        log("g2")
        log("result.data din axios getAvailableServicesListApi")
        log(result.data)
        log("g3")
        return result.data
    }catch(err){
        alert("alerta de eroare get getAvailableServicesList")
        log(err.value)
        // error.value = err.message
        return {error:true, message:"eroare la getAvailableServicesList",servicesList:{}}
    }
}


const useGetServicesAPI = () => {
    return { error, getAllServicesList, getAvailableServicesList, getPrepaidCardsServicesList, getImsiServiceDetailsApi, terminateService };
}
export default useGetServicesAPI
